module.exports = __webpack_public_path__ + "static/media/home-authentic-studio-image-02.ec6c140d.jpg";